import { API_BASE_URL } from '../config/constants';
import { ENDPOINTS } from '../config/endpoints';

/** Login-page ping only. Uses fetch so auth interceptors are not involved. */
export const pingHealth = () =>
  fetch(`${API_BASE_URL}${ENDPOINTS.HEALTH}`)
    .then((res) => (res.ok ? res.json() : null))
    .catch(() => null);
